import { observable, computed, action, makeObservable, toJS } from "mobx";
import { select_addr_forkakao, select_addr_forkakao_pos } from "../http/kakaoConn";
import { select_addr_fornaver_pos } from "http/addrConn"

class AddressSearchStore {

    constructor() {
        makeObservable(this);
    }

    // 카카오맵 좌표
    @observable
    _st_kakaoamp = {
        lat: "",
        lng: ""
    }

    get getKakaoMap() {
        return this._st_kakaoamp;
    }

    @computed
    get getKakaoMapLat() {
        return this._st_kakaoamp.lat;
    }

    @computed
    get getKakaoMapLng() {
        return this._st_kakaoamp.lng;
    }

    @action
    setKakaoMap(lat_val, lng_val) {
        this._st_kakaoamp = { lat: lat_val, lng: lng_val }
    }

    /**
     * 주소 검색 변경값
     * @type {string}
     * @private
     */
    @observable
    _st_detail_search_addr_val = "";

    get getDetailSearchAddr() {
        return this._st_detail_search_addr_val;
    }

    @action
    setDetailSearchAddr(val) {
        this._st_detail_search_addr_val = val;
        this._st_search_addr_list = [];
        this._st_search_addr_count = null;
        this.setSearchAddrResult(null)
    }

    @action
    setDetailNowSearchAddr(rootStore, val) {
        this._st_detail_search_addr_val = val;
        this._st_search_addr_list = [];
        this._st_search_addr_count = null;
        this.setSearchAddrResult(null)
        select_addr_forkakao_pos(rootStore)
        //select_addr_fornaver_pos(rootStore)
    }


    /**
     * 주소 상세 검색 변경값
     * @type {string}
     * @private
     */
    @observable
    _st_detail_search_addr_detail_val = "";

    get getDetailSearchAddrDetail() {
        return this._st_detail_search_addr_detail_val;
    }

    @action
    setDetailSearchAddrDetail(val) {
        this._st_detail_search_addr_detail_val = val;
    }

    /**
     * 주소 검색후 목록 관리
     * @type {[]}
     * @private
     */
    @observable
    _st_search_addr_list = []

    @computed
    get getSearchAddrList() {
        return toJS(this._st_search_addr_list);
    }

    @action
    setSearchAddrList(list) {
        this._st_search_addr_list = list.map(addr => {
            return { ...addr, click_obj: false, id: addr.id }
        });
    }

    @action
    initSearchAddrList() {
        this._st_search_addr_list = [];
    }

    @action
    setSearchAddrClickObj(addr_name, id) {
        this._st_search_addr_list = this._st_search_addr_list.map(addr => {
            if (addr.address === addr_name && id === addr.id) {
                return { ...addr, click_obj: true }
            } else {
                return { ...addr, click_obj: false }
            }

        });
    }

    /**
     * 주소 검색 오류 상태
     * @type String
     * @private
     */
    @observable
    _st_search_addr_result = ""

    @computed
    get getSearchAddrResult() {
        return this._st_search_addr_result;
    }

    @action
    setSearchAddrResult(resultValue) {  /* none, many */
        this._st_search_addr_result = resultValue;
    }

    @observable
    _addr_box_show_flag = false;

    get getAddrBoxShowFlag() {
        return this._addr_box_show_flag;
    }

    @action
    setAddrBoxShowFlag(flag) {
        this._addr_box_show_flag = flag;
    }

    /**
     * 주소 검색 api
     * @type String
     * @private
     */
    @observable
    _st_search_api_name = {
        api: "kakao",
        type: ""
    }

    @computed
    get getAddrApiName() {
        return this._st_search_api_name;
    }

    @action
    setAddrApiName(key, value) {
        this._st_search_api_name = { ...this._st_search_api_name, [key]: value }
    }

    /**
     * 선택한 배달주소지 정보
     * @type {{}}
     * @private
     */
    @observable
    _st_selected_addr = null;

    get getSelectedAddr() {
        return this._st_selected_addr;
    }

    @action
    setSelectedAddr(addr) {
        this._st_selected_addr = addr;
    }

    @action
    initSelectedAddr() {
        this._st_selected_addr = null;
    }

    @computed
    get getSelectAddrVal() {
        if (!this._st_selected_addr) {
            return "";
        }
        return this._st_selected_addr.address ? this._st_selected_addr.address.address_name : "";
    }

    @computed
    get getSelectRoadAddrVal() {
        if (!this._st_selected_addr) {
            return "";
        }
        return this._st_selected_addr.road_address ? this._st_selected_addr.road_address.address_name : "";
    }

    /**
     * 주소 검색 카운트 수(너무 많은 경우 표기를 위함)
     * @type {[]}
     * @private
     */
    @observable
    _st_search_addr_count = 0

    @computed
    get getSearchAddrCount() {
        return this._st_search_addr_count;
    }

    @action
    setSearchAddrCount(count) {
        this._st_search_addr_count = count
    }

    @observable
    _st_clicked_pos_address = "";

    get getClickedPosAddress() {
        return this._st_clicked_pos_address;
    }

    @action
    setClickedPosAddress(address) {
        this._st_clicked_pos_address = address;
    }

}

export default new AddressSearchStore();